





























import { defineComponent } from "@vue/composition-api";
import providers from "@/lib/api";
import { $t } from "@/lib/i18nHelpers";
import config from "@/config";
import { FormFields, FormValues } from "@/types";
import BaseButton from "@/components/BaseButton";
import BaseForm from "@/components/BaseForm";
import LoginContainer from "@/components/LoginContainer";
import SixDigitConfirmView from "@/components/SixDigitConfirmView";

export default defineComponent({
  name: "LoginPhone",
  components: { SixDigitConfirmView, BaseForm, BaseButton, LoginContainer },
  data() {
    return {
      valid: true,
      processing: false,
      codeSent: false,
      manualValidation: () => {},
      values: {
        phone: "",
      } as FormValues,
    };
  },
  computed: {
    fields(): FormFields {
      return [
        {
          name: "phone",
          label: $t("Phone number"),
          autofocus: true,
          rules: ["required"],
          validationMode: "aggressive",
          placeholder: "+",
          maskOpts: {
            showMaskOnFocus: false,
            showMaskOnHover: false,
            placeholder: "+",
            regex: "\\+\\d*",
          },
          type: "tel",
        },
      ];
    },
  },
  methods: {
    onBack() {
      this.codeSent = false;
    },
    async resendCode() {
      const phone = this.values.phone;
      await providers.LoginProvider.phoneLoginStart({ phone });
    },
    async sendCode() {
      try {
        const phone = this.values.phone;
        if (phone === "+") {
          this.values = { ...this.values, phone: "" };
          return;
        }
        this.manualValidation();
        if (!this.valid) {
          return;
        }
        this.processing = true;
        const result = await providers.LoginProvider.phoneLoginStart({ phone });
        if (result) {
          this.valid = true;
          this.codeSent = true;
        }
      } finally {
        this.processing = false;
      }
    },
    async onLogin(code: string) {
      try {
        const phone = this.values.phone;
        this.manualValidation();
        if (!this.valid) {
          return;
        }
        this.processing = true;
        await providers.LoginProvider.phoneLogin({
          data: {
            phone,
            code,
            role: config.userRegistrationRole,
          },
        });
        this.$emit("login");
      } finally {
        this.processing = false;
      }
    },
  },
});
